export const extractProductNameFromARI = (ari?: string): string | null => {
	if (!ari) {
		return null;
	}

	// see go/ari for possible values
	// Example:
	// ari:third-party:amplitude.amplitude::remote-link/org/{orgId}/chart/{chartId}
	// -> amplitude
	const ariParts = ari.split(':');

	if (ariParts.length < 3) {
		return null;
	}

	return ariParts[2];
};
